type UnitNumberFieldErrors = {
  hasDuplicateUnitNumber: boolean;
  hasEmptyUnitNumber: boolean;
  hasMaxCharactersUnitNumber: boolean;
};

export const getUnitNumberFieldErrors = (
  index: string,
  unitNumber: string,
  unitOverviewList: Record<string, { unitNumber: string }>,
  existingUnitNumbers: Array<string>,
): UnitNumberFieldErrors => {
  const trimmed = unitNumber.trim();
  const hasEmptyUnitNumber = trimmed === '';
  const hasMaxCharactersUnitNumber = unitNumber.length > 20;
  const hasDuplicateWithExisting = !hasEmptyUnitNumber && existingUnitNumbers.includes(trimmed);
  const hasDuplicateInForm =
    !hasEmptyUnitNumber &&
    Object.entries(unitOverviewList).some(([key, unit]) => key !== index && unit.unitNumber.trim() === trimmed);

  return {
    hasDuplicateUnitNumber: hasDuplicateWithExisting || hasDuplicateInForm,
    hasEmptyUnitNumber,
    hasMaxCharactersUnitNumber,
  };
};

export const shouldShowDuplicateUnitNumberError = (
  index: string,
  unitNumberErrors: UnitNumberFieldErrors,
  activeUnitNumberFieldIndex: string | null,
  unitOverviewList: Record<string, { unitNumber: string }>,
  existingUnitNumbers: Array<string>,
): boolean => {
  if (!unitNumberErrors.hasDuplicateUnitNumber) {
    return false;
  }

  if (index === activeUnitNumberFieldIndex) {
    return true;
  }

  if (activeUnitNumberFieldIndex === null) {
    return true;
  }

  const activeUnitNumber = unitOverviewList[activeUnitNumberFieldIndex]?.unitNumber ?? '';
  const activeFieldErrors = getUnitNumberFieldErrors(
    activeUnitNumberFieldIndex,
    activeUnitNumber,
    unitOverviewList,
    existingUnitNumbers,
  );

  return !activeFieldErrors.hasDuplicateUnitNumber;
};
